import { useContext } from "react";
import LineItemContext from "components/job/LineItem/LineItemContext";

export interface CustomQuotePropsHook {
  name: string;
}

export default function useCustomQuoteProps(): CustomQuotePropsHook {
  const { quoteDocument } = useContext(LineItemContext);

  const name = quoteDocument?.name || "Quote document";

  return { name };
}
